export class Branch {
  constructor(public id: number | null, public name: string) {}

  public static get EMPTY(): Branch {
    return new Branch(null, "");
  }

  hasValidName(): boolean {
    return !!this.name && this.name.trim().length > 0;
  }
}
